<!-- SERVICES -->
<section class="section section-gray">
  <div class="container">
    <div class="section-title">
      <h2>{{'main.logistics_solutions' | translate}}</h2>
      <p>Soluciones logísticas adaptadas a tus necesidades</p>
    </div>
    <div class="svc-grid">
      <a class="svc-card"
         *ngFor="let servicio of lista"
         [routerLink]="['/servicios', servicio.id]">
        <div class="svc-thumb">
          <picture>
            <source *ngFor="let source of servicio.sources"
              [srcset]="source.src"
              [media]="source.media"
              [type]="source.type">
            <img [alt]="servicio.titulo | translate" loading="lazy" />
          </picture>
        </div>
        <div class="svc-body">
          <h3>{{ servicio.titulo | translate }}</h3>
          <p>{{ servicio.descripcion | translate }}</p>
        </div>
      </a>
    </div>
  </div>
</section>
